import { render, staticRenderFns } from "./FreeTrialSwiperOS.vue?vue&type=template&id=ae5d4a1c&scoped=true"
import script from "./FreeTrialSwiperOS.vue?vue&type=script&setup=true&lang=ts"
export * from "./FreeTrialSwiperOS.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FreeTrialSwiperOS.vue?vue&type=style&index=0&id=ae5d4a1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae5d4a1c",
  null
  
)

export default component.exports